import NodeFixer from './NodeFixer';

export = new NodeFixer(fetch);
